import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";

import { Message } from "./message.model";

const ACTION_PREFIX = "[Message]";
export const MESSAGE_ACTION_TYPE = {
	add: `${ACTION_PREFIX} Add`,
	clearByMessageCode: `${ACTION_PREFIX} Clear by message code`,
	clearByContext: `${ACTION_PREFIX} Clear by context`,
	clearAll: `${ACTION_PREFIX} Clear all`,
};

@Injectable({
	providedIn: "root",
})
export class MessageAction {
	add(message: Message): ActionWithPayload {
		return {
			type: MESSAGE_ACTION_TYPE.add,
			payload: message,
		};
	}

	clearByCode(messageCode: string): ActionWithPayload {
		return {
			type: MESSAGE_ACTION_TYPE.clearByMessageCode,
			payload: messageCode,
		};
	}

	clearByContext(context: string): ActionWithPayload {
		return {
			type: MESSAGE_ACTION_TYPE.clearByContext,
			payload: context,
		};
	}

	clearAll(): Action {
		return {
			type: MESSAGE_ACTION_TYPE.clearAll,
		};
	}
}
